import { Box, Grid, TextField, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useState } from "react";

import defaultStyles from "./styles";

interface StyledTextFieldProps {
  children?: React.ReactNode;
  styles?: object;
  label?: string | JSX.Element;
  required?: boolean;
  completed?: boolean;
  allowCollapsible?: boolean;
  isActive?: boolean;
  [rest: string]: any;
}

export default function StyledTextField({
  styles = {},
  label = "",
  required = false,
  completed = false,
  allowCollapsible = false,
  isActive = false,
  ...rest
}: StyledTextFieldProps) {
  const [filled, setFilled] = useState(completed);

  return (
    <>
      {!filled && (
        <>
          {label && (
            <Typography gutterBottom>
              {label} {required ? "*" : ""}
            </Typography>
          )}
          <TextField
            {...rest}
            sx={[
              defaultStyles.root,
              styles,
              isActive && {
                "& fieldset.MuiOutlinedInput-notchedOutline": {
                  borderColor: "green.main",
                  borderWidth: 2,
                },
              },
            ]}
            onBlur={(e) => {
              if (allowCollapsible && completed) setFilled(true);
              rest.onBlur?.(e);
            }}
          />
        </>
      )}

      {filled && (
        <Grid
          alignItems="center"
          gap={2}
          container
          onClick={() => setFilled(false)}
          sx={{
            border: `1px solid ${grey[300]}`,
            borderRadius: "16px",
            p: 2,
            width: "100%",
            mb: 2,
            cursor: "pointer",
          }}
        >
          <Grid item xs>
            {label && (
              <Typography gutterBottom sx={{ color: "#151F16", fontSize: 12 }}>
                {label} {required ? "*" : ""}
              </Typography>
            )}
            {/* filled in value */}
            <Typography
              variant="body1"
              sx={{ color: "black", fontWeight: 500 }}
            >
              {rest.value}
            </Typography>
          </Grid>

          <Grid item xs="auto">
            <Box
              component="i"
              className="fa-regular fa-check"
              sx={{ color: "green.main" }}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
